import PropTypes from 'prop-types'
import React from 'react'
import content from 'pp-react-l10n'
import { connect } from 'transfer/utils/p2p-connect'

import glamorous from 'glamorous'
import glamorousIcon from 'lib/glamorous-icon'
import { mediaQueries } from 'transfer/styles'
import Media from 'react-media'

import { SIZE_MOBILE } from 'lib/styles/media-queries'
import FFSvg from '../icons/svg/profilefriendsandfamily.svg'
import CircledCheckMarkIcon from '../icons/react-check-mark-icon'
import { getCfpbDynamicContentKey } from '../../../../lib/contentUtils'
import { FREEP2P_TYPE } from '../../../../../../lib/constants'
import {
  Spot,
  BodyText,
  CaptionText,
  v2black,
  v2grey300,
  v2blue500,
} from '@paypalcorp/pp-react'
import { isDw2Repaint } from 'experiments/dw2Repaint'

const {
  phoneLandscapeMax: mobile,
  internetExplorer10and11: MSIE1011,
} = mediaQueries
const i18nPaymentType = content('transfer/inc/paymentTypeChoices')
const i18nFunnelPage = content('transfer/page/funnel')

const IconContainer = glamorous.div({
  ...(isDw2Repaint() && { marginTop: '0%' }),
  marginBottom: isDw2Repaint() ? '4%' : '6%',
  display: 'flex',
  justifyContent: 'center',
  // [mobile]: {
  // marginTop: 30,
  // },
})

const ProfileIconSVG = glamorousIcon({
  flex: '1 1 auto',
  height: 52,
  width: 40,
  [mobile]: {
    maxWidth: 40,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  '& svg': { height: '52', width: '40' },
})

const ButtonLink = glamorous.button(
  {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    border: isDw2Repaint() ? '0px' : '1px solid',
    borderRadius: '10px',
    backgroundColor: 'white',
    margin: '0 auto',
    position: 'relative',
    textDecoration: 'none',
    maxWidth: isDw2Repaint() ? '95%' : '360px',
    cursor: 'pointer',
    padding: isDw2Repaint() ? '1%' : '4%',
    transition: 'border-color ease .2s',
    color: isDw2Repaint() ? v2black : '#0070BA',
    width: '100%',
    alignItems: 'center',
    [MSIE1011]: {
      /*
       * This media query will add a bottom margin to the friends and family card
       * because IE doesn't understand grids in the conventional way. So we need
       * to add some spacing between the two cards.
       */
      marginBottom: isDw2Repaint() ? '3%' : '8%',
    },
  },
  ({ selected }) => ({
    ...(!isDw2Repaint() && {
      borderColor: selected ? '#00CF92' : '#E1E7EB',
      ':hover': {
        borderColor: selected ? '#00CF92' : '#009CDE',
      },
    }),
  })
)

const SelectContainer = glamorous.div(
  {
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
    boxSizing: 'border-box',
    borderRadius: '6px',
    backgroundColor: 'white',
    margin: '1% auto',
    position: 'relative',
    textDecoration: 'none',
    maxWidth: '28rem',
    cursor: 'pointer',
    padding: '6%',
    color: v2black,
    width: '100%',
    transition: 'border-color ease .2s',
    textAlign: 'center',
    [mobile]: {
      maxWidth: '95%',
    },
  },
  ({ selected }) => ({
    border: selected ? '3px solid' : '1px solid',
    boxShadow: selected ? '0 0 0 0.375rem rgb(16 114 235 / 16%)' : 'none',
    borderColor: selected ? v2blue500 : v2grey300,
    ':hover': {
      borderColor: v2blue500,
    },
  })
)

const PDescription = glamorous.p({
  position: 'relative',
  left: 0,
  bottom: 0,
  color: '#000000',
  margin: '4% 5% 0 5%',
  maxWidth: '380px',
  // [mobile]: {
  //   marginTop: '8%',
  //   bottom: '6px',
  // },
})
ProfileIconSVG.defaultProps = { svg: FFSvg }

class FriendsAndFamilyCard extends React.Component {
  static propTypes = {
    selected: PropTypes.bool.isRequired,
    handleClick: PropTypes.func.isRequired,
    freeP2PType: PropTypes.string.isRequired,
    isCFPBEnabledCountry: PropTypes.bool,
    userAccountType: PropTypes.string.isRequired,
    userSubscriptionType: PropTypes.string.isRequired,
    defaultCurrencyCode: PropTypes.string.isRequired,
    countryLocalizedName: PropTypes.string.isRequired,
  }

  static defaultProps = {
    selected: false,
  }

  render() {
    const {
      selected,
      userAccountType,
      isCFPBEnabledCountry,
      userSubscriptionType,
      freeP2PType,
      defaultCurrencyCode,
      countryLocalizedName,
    } = this.props

    let feeDescription
    switch (freeP2PType) {
      case FREEP2P_TYPE.EU:
        feeDescription = i18nFunnelPage('freep2p.description')
        break
      case FREEP2P_TYPE.NON_EU:
        feeDescription = i18nFunnelPage('freep2p.descriptionNonEU', {
          localCurrency: defaultCurrencyCode,
          countryName: countryLocalizedName,
        })
        break
      default:
        feeDescription = i18nPaymentType(
          getCfpbDynamicContentKey(
            'personal.description',
            isCFPBEnabledCountry,
            userAccountType,
            userSubscriptionType
          )
        )
    }

    return isDw2Repaint() ? (
      <Media query={`(max-width: ${SIZE_MOBILE}px)`}>
        {matches => (
          <SelectContainer onClick={this.props.handleClick} selected={selected}>
            <ButtonLink
              tabindex="0"
              id="personal"
              data-testid="ffcard"
              data-nemo="ffcard"
              name="personalPayment"
            >
              <IconContainer>
                <Spot name="personal-account" size="lg" aria-hidden={true} />
              </IconContainer>
              <BodyText strong>{i18nPaymentType('personal.title')}</BodyText>
              {matches ? (
                <CaptionText>{feeDescription}</CaptionText>
              ) : (
                <BodyText>{feeDescription}</BodyText>
              )}
            </ButtonLink>
          </SelectContainer>
        )}
      </Media>
    ) : (
      <ButtonLink
        tabindex="0"
        id="personal"
        className="txtCenter"
        name="personalPayment"
        onClick={this.props.handleClick}
        data-testid="ffcard"
        data-nemo="ffcard"
        selected={selected}
      >
        {selected && <CircledCheckMarkIcon />}
        <div>
          <IconContainer>
            <ProfileIconSVG />
          </IconContainer>
          <div className="vx_text-3">{i18nPaymentType('personal.title')}</div>
          <PDescription className="vx_text-6_lighter">
            {feeDescription}
          </PDescription>
        </div>
      </ButtonLink>
    )
  }
}

export default connect(({ server, user }) => ({
  freeP2PType: server.freeP2PType,
  userAccountType: server.userAccountType,
  userSubscriptionType: user.subscriptionType,
  defaultCurrencyCode: server.defaultCurrencyCode,
  countryLocalizedName: server.countryLocalizedName,
}))(FriendsAndFamilyCard)
